import SelectedCountriesHandler from '../../utils/selected-countries-handler';
import ResponsibleOfficeModule from '../../modules/responsible-office-module';
import CompetenceModule from '../../modules/competence-module';
import StaticStateModule from "../../modules/static-state-module";

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.selCountries = new SelectedCountriesHandler();
		this.competencesModule = new CompetenceModule();
		this.responsibleOfficeModule = new ResponsibleOfficeModule();
        this.staticStateModule = new StaticStateModule(this.responsibleOfficeModule);
    }

	run() {
        if (!!this.metaDescription) {
            document.title = 'Anerkennungs- und Beratungsstellen in Deutschland - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
            this.metaDescription.setAttribute('content', 'Informationen zu Anerkennungsbehörden für die akademische und berufliche Anerkennung in Deutschland, und zu weiteren beratenden Stellen.');
        }
		this.staticStateModule.loadLocations().then(() => {
			this.initializeModules();
            this.competencesModule.loadCompetences();
            this.responsibleOfficeModule.getData().then();
		});
	}


	initializeModules() {
        this.staticStateModule.addEventListener(this.responsibleOfficeModule);
		this.responsibleOfficeModule.initialise(this.staticStateModule, this.competencesModule);
		this.responsibleOfficeModule.dataTable.modalDom.addEventListener();
		this.competencesModule.addEventListener(this.responsibleOfficeModule);
	}
}
const main = new Main();
main.run();


